<div class="completed-maintenance-overview">
  <div class="completed-maintenance-overview__content">
    <div class="content-left">
      <app-completed-maintenances-table
        [completedMaintenances]="completedMaintenances"
        [isLoading]="isLoading"
        [hasError]="hasError"
        [searchTerm]="searchTerm"
        [currentPage]="currentPage"
        [pageSize]="pageSize"
        [totalCount]="totalCount"
        [totalPages]="totalPages"
        (searchTermUpdated)="onSearchTermUpdate($event)"
        (exportClicked)="onExportClick()"
        (pageChanged)="onPageChange($event)">
      </app-completed-maintenances-table>
    </div>

    <div class="content-right">
      <div class="chart-card">
        <app-preventive-vs-reactive></app-preventive-vs-reactive>
      </div>

      <div class="chart-card">
        <app-reactive-maintenance-graph></app-reactive-maintenance-graph>
      </div>
    </div>
  </div>
</div>